import { Outlet } from "react-router";

export default function QrphLayout() {
  return (
    <main className=" min-h-screen flex flex-col">
      <Outlet />
    </main>
  );
}
